import SettingsModule, {SettingsMenuTopCategory} from "../../../core/modules/settings-module"

export default class McpSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "MCP Server",
            description              : "The GoodDay MCP server connects your GoodDay account to AI assistants that support the Model Context Protocol (MCP), such as Claude, ChatGPT, and Gemini. Once connected, you can access and manage your GoodDay data directly from your AI assistant.",
            svgIcon                  : "isvg-mcp-integration",
            settingsUrl              : "settings/mcp",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integration",
            keywords                 : "mcp model context protocol server ai claude chatgpt gemini",
        })

        // available to every user, not managers only
        this.canAccess      = true

        this.hasStatus      = false
    }
}
